module.exports = __webpack_public_path__ + "img/客服.cd90c075.svg";